// extracted by mini-css-extract-plugin
export default {"FillControl":"Fill_FillControl__6eU3B","DeleteIcon":"Fill_DeleteIcon__t6YC8"};